// App
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';

// Misc / utils
import numberUtils from 'app/shared/utils/numberUtils';

export const usePriceFilterButtonLabel = () => {
  // Redux
  const priceState = useSelector((state: RootReduxState) => state.filter.price);
  const onlyHasMinPrice = priceState.min && priceState.max === null;
  const onlyHasMaxPrice = (priceState.min === null || priceState.min === 0) && priceState.max;
  const hasBothMinMaxPrice = priceState.min && priceState.max;
  const noMinOrMaxPrice = priceState.min === null && priceState.max === null;

  const getButtonLabel = () => {
    const DEFAULT_LABEL = 'Any price';

    if (noMinOrMaxPrice) {
      return DEFAULT_LABEL;
    } else {
      if (hasBothMinMaxPrice) {
        return `${numberUtils.asCurrency(priceState.min)}–${numberUtils.asCurrency(priceState.max)}`;
      } else if (onlyHasMinPrice) {
        return `> ${numberUtils.asCurrency(priceState.min)}`;
      } else if (onlyHasMaxPrice) {
        return `< ${numberUtils.asCurrency(priceState.max)}`;
      }
    }
  };

  const getButtonStatus = () => {
    if (priceState.min !== null || priceState.max !== null) {
      return true;
    }

    return false;
  };

  return [getButtonLabel, getButtonStatus];
};
